import script from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=d82ca6cc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d82ca6cc"]])

export default __exports__